// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3Djek","errorLogs":"EditorFooter_errorLogs__2Slm3"};